import { request } from 'app/utils';
import { useSchool } from 'features/school';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  getOffers,
  setBuyInformationAction,
  setCheckoutAction,
  clearCheckoutAction,
  setLoginAction,
  setPaymentsResponseAction,
  setActiveCampaingIdsAction,
  setCaptchaAction,
} from './redux/slice';
import { ActiveCampaingIdsState, BuyCaptcha, BuyInformationResponse, CheckoutState, PaymentsResponse } from './types';

const useOffers = () => {
  const offers = useSelector(getOffers);

  const dispatch = useDispatch();

  const { defaultAppUrl, apiGatewayUrl, schoolAlias } = useSchool();

  const setBuyInformation = (received: BuyInformationResponse) => {
    dispatch(setBuyInformationAction(received));
  };

  const clearBuyInformation = () => {
    dispatch(setBuyInformationAction(undefined!));
  };

  const setCheckout = (received: Partial<CheckoutState>, sendLead: boolean = true) => {
    dispatch(setCheckoutAction({ ...received, sendLead }));
  };

  const setLogin = (
    received: Partial<{
      showLogin: boolean;
      showLoginMessage: boolean;
      bypassLogin: boolean;
      hasAccount: boolean;
    }>
  ) => {
    dispatch(setLoginAction({ ...received }));
  };

  const clearCheckout = () => {
    dispatch(clearCheckoutAction());
  };

  const setPaymentsResponse = (received: PaymentsResponse) => {
    dispatch(setPaymentsResponseAction(received));
  };

  const setActiveCampaingIds = (received: Partial<ActiveCampaingIdsState>) => {
    dispatch(setActiveCampaingIdsAction(received));
  };

  const setCaptcha = (received: BuyCaptcha) => {
    dispatch(setCaptchaAction(received));
  };

  const getOfferLink = useCallback(
    (identifier: string) => {
      let offerLink = `https://${defaultAppUrl}/${identifier}/checkout`;

      if (window.location.hostname === 'localhost') {
        offerLink = `http://localhost:3000/${identifier}/checkout`;
      }

      return offerLink;
    },
    [defaultAppUrl]
  );

  const getCaptcha = useCallback(
    async (offerIdentifier: string) =>
      await request<BuyCaptcha>({
        url: `/api/v1/OfferPayment/Captcha/${offerIdentifier}`,
        method: 'get',
        baseURL: apiGatewayUrl,
        params: {
          schoolAlias,
        },
      })
        .then(({ data }) => {
          setCaptcha(data);
        })
        .catch(console.error),
    [apiGatewayUrl, schoolAlias]
  );

  return {
    ...offers,
    setBuyInformation,
    clearBuyInformation,

    setCheckout,
    clearCheckout,

    setLogin,

    setPaymentsResponse,

    setActiveCampaingIds,

    setCaptcha,
    getCaptcha,

    getOfferLink,
  };
};

export default useOffers;
